export enum DietaryRestriction {
  NONE = 'None',
  DAIRY_FREE = 'Dairy-Free',
  GLUTEN_FREE = 'Gluten-Free',
  HALAL = 'Halal',
  KOSHER = 'Kosher',
  VEGAN = 'Vegan',
  VEGETARIAN = 'Vegetarian',
}
export default DietaryRestriction;
